import React, { useState } from "react";
import PropTypes from "prop-types";

export function useSelectRowOpenModal(props) {
  const [Open, setOpen] = useState(false);
  const [Data, setData] = useState();
  return {
    isOpen: Open,
    onOpen: () => {
      setOpen(true);
    },
    onClose: () => {
      setOpen(false);
      setData(null);
    },
    Data,
    handleClickRow: (data) => {
      setOpen(true);
      setData(data);
    },
  };
}

useSelectRowOpenModal.propTypes = {};
